module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/1-8ae9afe48c9a68b1c7b3f43067b97399.jpg";